import React from "react";
import { Themes, ThemesName } from "./themes";
import { generateTheme } from "./util";

export const ThemePallete = ({setCustomTheme, setThemeName}: any) => {
    if(APP_MODE === "production") {
        return null;
    }
    return (
        <div className="theme-provider-thems" style={{ position: "fixed", bottom: 0, left: "20px", zIndex: 9999, backgroundColor: "#FFFFFF", padding: "5px" }}>
            <div style={{ display: 'flex' }}>
                {Object.keys(Themes).map((themeName: ThemesName) => <div onClick={() => {
                    setCustomTheme?.(null);
                    setThemeName?.(themeName)
                }}><div style={{ backgroundColor: Themes[themeName]?.primaryBackground, border: "1px solid", width: 50, height: 27, cursor: "pointer", marginRight: 5 }}></div></div>)}
                <div><input type="color" onChange={({target}) => setCustomTheme(generateTheme(target?.value))} /></div>
            </div>
        </div>
    )
}